import React from 'react';

import { Paper } from '@mui/material';

import classes from './VideoList.module.scss';
import { Video } from '../../../../../interface/video';
import { VideoPreview } from '../../../../../components/VideoPreview/VideoPreview';

type VideoListProps = {
  videos: Video[];
};

const VideoList = ({ videos }: VideoListProps) => {
  return (
    <Paper variant="roundedBox" className={classes.videoBox}>
      {videos.map((video) => (
        <div key={video.id}>
          <VideoPreview
            imgSrc={video.image}
            videoLink={video.youtubevideo}
            className={classes.videoPreview}
          />
          <p className={classes.videoTitle}>{video.title}</p>
        </div>
      ))}
    </Paper>
  );
};

export { VideoList };
